import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '@app/material/material.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ColorPickerModule } from 'ngx-color-picker';
import { SharedModule } from '@app/shared/shared.module';

// Huddle flow components (files remain in super-admin/components/)
import { UploadDesignComponent } from '@app/feature/super-admin/components/upload-design/upload-design.component';
import { DesignPreviewComponent } from '@app/feature/super-admin/components/design-preview/design-preview.component';
import { ProductColorSelectionComponent } from '@app/feature/super-admin/components/product-color-selection/product-color-selection.component';
import { ProductPricingTagsComponent } from '@app/feature/super-admin/components/product-pricing-tags/product-pricing-tags.component';
import { EditMasterProductComponent } from '@app/feature/super-admin/components/edit-master-product/edit-master-product.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    MaterialModule,
    MatProgressBarModule,
    AngularEditorModule,
    ColorPickerModule,
    SharedModule
  ],
  declarations: [
    UploadDesignComponent,
    DesignPreviewComponent,
    ProductColorSelectionComponent,
    ProductPricingTagsComponent,
    EditMasterProductComponent
  ],
  exports: [
    UploadDesignComponent,
    DesignPreviewComponent,
    ProductColorSelectionComponent,
    ProductPricingTagsComponent,
    EditMasterProductComponent
  ]
})
export class HuddleFlowModule {}
